import React from 'react';
import OpenAILogo from '@/components/icons/OpenAILogo';

// StatCard component without tooltip functionality
const StatCard: React.FC<{
  title: string;
  value: string;
  footer: string;
  tooltipContent: React.ReactNode; // Keep this prop to avoid changing all call sites
  isOpenBrain?: boolean;
}> = ({ title, value, footer, tooltipContent, isOpenBrain = false }) => (
  <div className={`px-4 py-2 rounded-md h-full ${isOpenBrain ? "bg-[var(--accent)] text-white" : "border border-black"} relative`}>
    {isOpenBrain && (
      <div className="absolute top-2 right-2">
        <OpenAILogo size={20} color="white" />
      </div>
    )}
    <div className={`text-[10px] uppercase mb-1 ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{title}</div>
    <div className="text-2xl font-bold">{value}</div>
    <div className={`text-[10px] ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{footer}</div>
  </div>
);

const KeyMetrics2027: React.FC = () => {
  return (
    <div className="font-mono mt-8 mb-8">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Global AI Title + First Stat */}
        <div className="order-10 lg:order-none">
          <StatCard 
            title="GLOBAL AI CAPEX"
            value="$2T"
            footer="COST OF OWNERSHIP OF ACTIVE COMPUTE"
            tooltipContent={"Total global capital expenditure on AI infrastructure."}
          />
        </div>

        {/* Title - spans 2 columns */}
        <div className="col-span-2">
          <h2 className="text-[40px] font text-right not-italic mt-0 mb-0 font-bold font-sans tracking-tight uppercase">KEY METRICS 2027</h2>
          {/* <h3 className="text-xl font-bold mb-4 uppercase italic bg-[var(--accent)] text-white inline-block px-2 py-1">OpenBrain</h3> */}
        </div>

        {/* Global AI stats - row 2 */}
        <div className="order-11 lg:order-none">
          <StatCard 
            title="GLOBAL AI POWER"
            value="60GW"
            footer="PEAK POWER"
            tooltipContent={"Global peak power consumption by AI systems."}
          />
        </div>
        
        {/* OpenBrain stats - row 1, columns 1-2 */}
        <div className="order-1 lg:order-none">
          <StatCard 
            title="OPENBRAIN REVENUE"
            value="$140B"
            footer="2027 ANNUAL"
            tooltipContent={"OpenBrain's projected annual revenue for 2027."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-2 lg:order-none">
          <StatCard 
            title="TOTAL CAPITAL EXPENDITURE"
            value="$400B"
            footer="COST OF OWNERSHIP OF OPENBRAIN'S ACTIVE COMPUTE"
            tooltipContent={"Total capital expenditure for OpenBrain's computing infrastructure."}
            isOpenBrain={true}
          />
        </div>

        {/* Global AI stats - row 3 */}
        <div className="order-12 lg:order-none">
          <StatCard 
            title="SHARE OF US POWER ON AI"
            value="3.5%"
            footer="50 GW OF 1.35TW CAPACITY"
            tooltipContent={"Percentage of US electrical capacity used for AI operations."}
          />
        </div>
        
        {/* OpenBrain stats - row 2, columns 1-2 */}
        <div className="order-3 lg:order-none">
          <StatCard 
            title="OPENBRAIN COMPUTE COSTS"
            value="$100B"
            footer="2027 ANNUAL"
            tooltipContent={"Annual compute costs for OpenBrain operations."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-4 lg:order-none">
          <StatCard 
            title="OPENBRAIN POWER REQUIREMENT"
            value="10GW"
            footer="PEAK POWER"
            tooltipContent={"Peak power requirements for OpenBrain's computing infrastructure."}
            isOpenBrain={true}
          />
        </div>
      </div>
    </div>
  );
};

export default KeyMetrics2027;